export default __webpack_public_path__ + "static/media/team1.59fdcb1b.JPG";